<template>
  <card-dashboard class="h-[110px]">
    <div class="card-report flex" :class="heightFull">
      <div class="card-icon w-12 h-14 text-center flex-shrink-0">
        <md-icon>
          <i :class="icon" class="text-3xl text-white"></i>
        </md-icon>
      </div>
      <div class="flex-grow-[2] flex flex-col justify-between w-full">
        <h3 class="card-title text-sm">{{ title }}</h3>
        <slot></slot>
      </div>
    </div>
    <slot name="report-admin"></slot>
  </card-dashboard>
</template>
<script>
import CardDashboard from "./CardDashboard";
export default {
  name: "card-report",
  components: { CardDashboard },
  props: ["icon", "title", "heightFull"]
};
</script>
<style lang="scss" scoped>
.card-report {
  .card-icon {
    background-color: #2d82b5 !important;
    line-height: 50px;
    margin-top: -30px;
    margin-right: 10px;
    border-radius: 3px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);
  }
}
</style>
